import { types } from "mobx-state-tree";

import ScheduleStore from "../schedule/schedule-store";

const HomeUIStore = types
    .model(`HomeUIStore`, {
        showBroadcastModal: false,
        showListenerModal: false,
        showStreamScheduleCalendarModal: false,
        selectedScheduleStreamId: types.maybeNull(types.string),
        showScheduleStreamCreateEditModal: false,
        selectedScheduleStreamCreateEditId: types.maybeNull(types.string),
        streamSchedule: types.maybe(ScheduleStore),
        showTurnOnStreamScheduleModal: false,
        showTurnOffStreamScheduleModal: false,
        selectedBroadcastStreamId: types.maybeNull(types.string),
        selectedContextId: types.optional(types.string, ``),
        streamsHaveChanged: false,
        streamsLastChanged: types.maybeNull(types.integer)
    })
    .volatile(() => ({
        STREAMS_REFRESH_INTERVAL: 30000,
        streamsRefreshTimer: null
    }))
    .actions((self) => ({
        setBroadcastModalVisibility(visible: boolean) {
            self.showBroadcastModal = visible;
        },
        setSelectedBroadcastStreamId(id: string) {
            self.selectedBroadcastStreamId = id;
        },
        setSelectedScheduleStreamCreateEditId(id: string) {
            self.selectedScheduleStreamCreateEditId = id;
        },
        setStreamSchedule(schedule) {
            self.streamSchedule = schedule;
        },
        setScheduleStreamCreateEditModalVisibility(visible: boolean) {
            self.showScheduleStreamCreateEditModal = visible;
        },
        setSelectedScheduleStreamId(id: string) {
            self.selectedScheduleStreamId = id;
        },
        setStreamScheduleCalendarModalVisibility(visible: boolean) {
            self.showStreamScheduleCalendarModal = visible;
        },
        setTurnOnStreamScheduleModalVisibility(visible: boolean) {
            self.showTurnOnStreamScheduleModal = visible;
        },
        setTurnOffStreamScheduleModalVisibility(visible: boolean) {
            self.showTurnOffStreamScheduleModal = visible;
        }
    }))
    .actions((self) => ({
        openBroadcastModal({ streamId }: { streamId: string }) {
            self.setSelectedBroadcastStreamId(streamId);
            self.setBroadcastModalVisibility(true);
        },
        closeBroadcastModal() {
            self.setBroadcastModalVisibility(false);
        },
        openScheduleStreamCreateEditModal(streamId: string, scheduleData) {
            self.setSelectedScheduleStreamCreateEditId(streamId);
            self.setStreamSchedule(scheduleData);
            self.setScheduleStreamCreateEditModalVisibility(true);
        },
        closeScheduleStreamCreateEditModal() {
            self.setScheduleStreamCreateEditModalVisibility(false);
        },
        openStreamScheduleCalendarModal(streamId: string, scheduleData) {
            self.setSelectedScheduleStreamId(streamId);
            self.setStreamSchedule(scheduleData);
            self.setStreamScheduleCalendarModalVisibility(true);
        },
        closeStreamScheduleCalendarModal() {
            self.setStreamScheduleCalendarModalVisibility(false);
        },
        openTurnOnStreamScheduleModal(streamId: string) {
            self.setSelectedScheduleStreamId(streamId);
            self.setTurnOnStreamScheduleModalVisibility(true);
        },
        closeTurnOnStreamScheduleModal() {
            self.setTurnOnStreamScheduleModalVisibility(false);
        },

        openTurnOffStreamScheduleModal(streamId: string) {
            self.setSelectedScheduleStreamId(streamId);
            self.setTurnOffStreamScheduleModalVisibility(true);
        },
        closeTurnOffStreamScheduleModal() {
            self.setTurnOffStreamScheduleModalVisibility(false);
        },

        setSelectedContextId(id: string) {
            self.selectedContextId = id;
        },
        startPollingStreams(fetchFunc: (...args: unknown[]) => void) {
            if (!self.streamsRefreshTimer) {
                self.streamsRefreshTimer = setInterval(
                    fetchFunc,
                    self.STREAMS_REFRESH_INTERVAL
                );
            }
        },
        stopPollingStreams() {
            clearInterval(self.streamsRefreshTimer);
            self.streamsRefreshTimer = null;
        }
    }));

export default HomeUIStore;
